import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { useSnackbar } from 'notistack';

import Input from 'src/componentes/input';
import PerfilLookup from 'src/lookups/perfil';
import StrongPassword from 'src/componentes/StrongPassword';
import CheckBox from 'src/componentes/checkbox';
import { filterTree } from 'src/utils/tree';
import ModulosColaborador from './ModulosColaborador';
import LoadingContainer from 'src/componentes/loading-container';
import Button from 'src/componentes/button';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import useAuth from 'src/hooks/useAuth';
import Confirm from 'src/componentes/message-box/confirm';
import ContentManager from 'src/componentes/content-manager';
import Radio from 'src/componentes/radio';
import { TIPO_LOGIN } from 'src/utils/constants';
import { MODULOS } from 'src/utils/constants';
import { uperCaseAllLetter } from 'src/utils/string';

const Usuario = ({ model, modulos, disabled = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [disabledMFAReset, setDisabledMFAReset] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { user, utilizandoAdfs, hybridAuthenticationEnabled } = useAuth();
  const intl = useIntl();

  const obterIdsCompartilhamento = () => {
    let compartilhamento = model.getValue('compartilhamento');
    return compartilhamento
      ? filterTree(
          compartilhamento,
          'children',
          (item) => item.selecionado
        ).map((i) => i.id)
      : [];
  };

  const handleResetMFA = (userCode) => {
    setIsLoading(true);

    http
      .post(`/Colaborador/ResetMFA`, {
        userCode: userCode,
      })
      .then(() => {
        setDisabledMFAReset(true);

        model.getModel('habilitadoMFA').requestChange(false);

        setIsLoading(false);

        enqueueSnackbar(
          intl.formatMessage({
            id: 'metodoVerificacaoRedefinidoSucesso',
          }),
          {
            variant: 'success',
          }
        );
      })
      .catch((error) => {
        setIsLoading(false);
        errorHandler(error);
      });
  };

  const handleConfirmResetMFA = (userCode) => {
    ContentManager.addContent(
      <Confirm
        message={<FormattedMessage id="desejaMesmoResetarMFA" />}
        handleConfirm={() => handleResetMFA(userCode)}
      />
    );
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      <Row>
        {!disabled && (
          <Col md={6}>
            <Input model={model.getModel('email')} disabled={disabled} />
          </Col>
        )}
        <Col md={6}>
          <PerfilLookup
            model={model.getModel('perfis')}
            data={{ itensId: obterIdsCompartilhamento() }}
            multiple={true}
          />
        </Col>
      </Row>
      {!disabled && (
        <Row>
          <Col md={4}>
            <Input autoComplete="off" model={model.getModel('nomeUsuario')} />
          </Col>

          <Col md={4}>
            <StrongPassword
              model={model.getModel('senhaAlterada')}
              userName={model.getModel('nomeUsuario').value}
              email={model.getModel('email').value}
            />
          </Col>

          <Col md={4}>
            <CheckBox
              style={{
                marginTop: model.getModel('adLdapAtivo').value ? 10 : 30,
              }}
              model={model.getModel('bloqueadoTentativaLogin')}
            />
            {model.getModel('adLdapAtivo').value && (
              <CheckBox model={model.getModel('utilizarAdLdap')} />
            )}
          </Col>

          {user?.usuarioPerfilAdmin &&
            (!utilizandoAdfs ||
              (utilizandoAdfs &&
                hybridAuthenticationEnabled &&
                model.getModel('tipoLogin')?.value?.id ===
                  TIPO_LOGIN.SENHA)) && (
              <Col md={8}>
                <Button
                  disabled={disabledMFAReset}
                  onClick={() =>
                    handleConfirmResetMFA(model.getModel('idIntegracao')?.value)
                  }
                  iconSize={15}
                  color="primary"
                  leftIcon="lock-reset"
                >
                  <FormattedMessage id="redefinirMFA" />
                </Button>
              </Col>
            )}

          {utilizandoAdfs &&
            user?.usuarioPerfilAdmin &&
            hybridAuthenticationEnabled && (
              <Col md={8} className="mt-3">
                <div className="d-flex flex-column">
                  <span className="font-weight-bolder ">
                    <FormattedMessage id="label.login" />
                  </span>

                  <span className="font-weight-bolder text-muted text-sm">
                    <FormattedMessage id="comoUsuarioFaraLogin" />
                  </span>
                </div>

                <Radio
                  className="mt-3"
                  inColum
                  colunaUnica
                  required
                  model={model.getModel('tipoLogin')}
                  options={[
                    { id: 1, descricao: intl.formatMessage({ id: 'senha' }) },
                    {
                      id: 2,
                      descricao: uperCaseAllLetter(
                        intl.formatMessage({ id: 'sso' })
                      ),
                    },
                  ]}
                  hintItens={[
                    {
                      id: 1,
                      label: intl.formatMessage({ id: 'tipoLoginSenhaHint' }),
                    },
                    {
                      id: 2,
                      label: intl.formatMessage({
                        id: 'tipoLoginSsoHint',
                      }),
                    },
                  ]}
                  name="tipoLogin"
                  labelField="descricao"
                  idField="id"
                />
              </Col>
            )}

          {model.getValue('podeAlterarModulos') && (
            <Col md={12}>
              <hr />
              <ModulosColaborador
                model={model}
                modulos={modulos?.filter((e) => {
                  return e.id !== MODULOS.INTELIGENCIA_ARTIFICIAL_PREMIUM;
                })}
              />
            </Col>
          )}
        </Row>
      )}
    </LoadingContainer>
  );
};

export default Usuario;
